import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((_) => ({
  reportContainer: {
    display: 'flex',
  },
  report: {
    maxWidth: '50%',
    width: '100%',
    padding: 0,
  },
  bindTop: {
    alignItems: 'flex-start',
  },
}));
